/**
 * B-20. A name is public, so an email address typed as one is refused before
 * it is sent. Any at sign counts: "@", the full-width one a CJK keyboard types
 * (U+FF20) and the small one (U+FE6B). Those two are the only characters whose
 * compatibility form (NFKC) contains "@". The server applies the same rule on
 * every path that sets a name (server/users/helpers/publicName.js).
 */
export const NAME_AT_SIGN = /[@﹫＠]/;

export const NO_EMAIL_AS_NAME =
  "Please don't use an email address as your name. Other collectors see it.";

/**
 * Owner decision Q-13: a one-character first or last name is allowed only when
 * that character is a Chinese, Japanese or Korean letter (李, 林 and 김 are
 * whole family names). A copy of the server's table, which names each range
 * (server/users/helpers/publicName.js); publicName.parity.test.js checks that
 * both accept the same characters.
 */
export const ONE_CHARACTER_NAME =
  /^[\u{3041}-\u{3096}\u{309F}\u{30A1}-\u{30FA}\u{30FF}\u{31F0}-\u{31FF}\u{FF66}-\u{FF6F}\u{FF71}-\u{FF9D}\u{3400}-\u{4DBF}\u{4E00}-\u{9FFF}\u{F900}-\u{FAFF}\u{20000}-\u{323AF}\u{AC00}-\u{D7A3}]$/u;

/**
 * Long enough to be a first or last name: 2+ characters, or one Chinese,
 * Japanese or Korean letter. It counts characters the way the `length < 2`
 * checks it replaced did, and does not trim: the sign-up form never trimmed,
 * and the other callers trim first.
 */
export const nameLongEnough = (value) => {
  const v = String(value ?? "");
  return v.length >= 2 || ONE_CHARACTER_NAME.test(v);
};
